// // src/store/slices/walletSlice.js
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import walletApi from "api/walletApi";

// export const fetchWallets = createAsyncThunk(
//   "wallet/fetchAll",
//   async ({ page = 1, pageSize = 10, search = "" }, { rejectWithValue }) => {
//     try {
//       const res = await walletApi.getAll(page, pageSize, search);
//       return res.data;
//     } catch (e) {
//       return rejectWithValue(
//         e.response?.data?.detail || "Failed to load wallets"
//       );
//     }
//   }
// );

// export const creditWallet = createAsyncThunk(
//   "wallet/credit",
//   async ({ walletId, amount }, { rejectWithValue }) => {
//     try {
//       const res = await walletApi.creditWallet(walletId, { amount });
//       return res.data; // returns updated wallet
//     } catch (e) {
//       return rejectWithValue(
//         e.response?.data || { amount: ["Invalid amount"] }
//       );
//     }
//   }
// );

// export const debitWallet = createAsyncThunk(
//   "wallet/debit",
//   async ({ walletId, amount }, { rejectWithValue }) => {
//     try {
//       const res = await walletApi.debitWallet(walletId, { amount });
//       return res.data; // should return updated wallet
//     } catch (e) {
//       return rejectWithValue(
//         e.response?.data || {
//           amount: ["Insufficient balance or invalid amount"],
//         }
//       );
//     }
//   }
// );

// // export const fetchWalletHistory = createAsyncThunk(
// //   "wallet/fetchHistory",
// //   async ({ walletId }, { rejectWithValue }) => {
// //     try {
// //       const res = await walletApi.getHistory(walletId);
// //       return { walletId, history: res.data.data || res.data };
// //     } catch (e) {
// //       return rejectWithValue("Failed to load history");
// //     }
// //   }
// // );

// export const fetchWalletHistory = createAsyncThunk(
//   "wallet/fetchHistory",
//   async ({ walletId = null, search = "", page = 1, pageSize = 10 }, { rejectWithValue }) => {
//     try {
//       const res = await walletApi.getHistory(walletId, search, page, pageSize);
//       const historyData = res.data?.data || res.data || [];
//        const pagination = res.data?.pagination || { count: historyData.length };

//       return {
//         walletId,
//         history: historyData,
//         pagination,
//         search,
//       };
//     } catch (e) {
//       return rejectWithValue("Failed to load wallet history");
//     }
//   }
// );

// const walletSlice = createSlice({
//   name: "wallet",
//   initialState: {
//     wallets: [],
//     history: {},
//     pagination: { count: 0, page_size: 10 },
//     isLoading: false,
//     error: null,
//   },
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchWallets.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(fetchWallets.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.wallets = action.payload.data || action.payload;
//         state.pagination = action.payload.pagination || {
//           count: action.payload.length,
//         };
//       })
//       .addCase(fetchWallets.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload;
//       })
//       .addCase(creditWallet.fulfilled, (state, action) => {
//         const idx = state.wallets.findIndex((w) => w.id === action.payload.id);
//         if (idx !== -1) state.wallets[idx] = action.payload;
//       })
//       .addCase(creditWallet.rejected, (state, action) => {
//         state.error = action.payload;
//       })
//       .addCase(fetchWalletHistory.pending, (state) => {
//         state.isLoading = true;
//       })
//       // .addCase(fetchWalletHistory.fulfilled, (state, action) => {
//       //   state.isLoading = false;
//       //   state.history[action.payload.walletId] = action.payload.history;
//       // })
//         .addCase(fetchWalletHistory.fulfilled, (state, action) => {
//         state.isLoading = false;
//         const { walletId, history, pagination } = action.payload;

//         // FIXED: Store global history under key "global" (not null)
//         const key = walletId === null ? "global" : walletId;
//         state.history[key] = {
//           items: history,
//           pagination,
//         };
//       })
//       .addCase(fetchWalletHistory.rejected, (state) => {
//         state.isLoading = false;
//       })
//       .addCase(debitWallet.fulfilled, (state, action) => {
//         const idx = state.wallets.findIndex((w) => w.id === action.payload.id);
//         if (idx !== -1) state.wallets[idx] = action.payload;
//       })
//       .addCase(debitWallet.rejected, (state, action) => {
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearError } = walletSlice.actions;
// export default walletSlice.reducer;

// src/store/slices/walletSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import walletApi from "api/walletApi";

export const fetchWallets = createAsyncThunk(
  "wallet/fetchAll",
  async ({ page = 1, pageSize = 10, search = "" }, { rejectWithValue }) => {
    try {
      const res = await walletApi.getAll(page, pageSize, search);
      return res.data;
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.detail || "Failed to load wallets"
      );
    }
  }
);

export const creditWallet = createAsyncThunk(
  "wallet/credit",
  async ({ walletId, amount }, { rejectWithValue }) => {
    try {
      const res = await walletApi.creditWallet(walletId, { amount });
      return res.data; // returns updated wallet
    } catch (e) {
      return rejectWithValue(
        e.response?.data || { amount: ["Invalid amount"] }
      );
    }
  }
);

export const debitWallet = createAsyncThunk(
  "wallet/debit",
  async ({ walletId, amount }, { rejectWithValue }) => {
    try {
      const res = await walletApi.debitWallet(walletId, { amount });
      return res.data; // should return updated wallet
    } catch (e) {
      return rejectWithValue(
        e.response?.data || {
          amount: ["Insufficient balance or invalid amount"],
        }
      );
    }
  }
);

// export const fetchWalletHistory = createAsyncThunk(
//   "wallet/fetchHistory",
//   async ({ walletId }, { rejectWithValue }) => {
//     try {
//       const res = await walletApi.getHistory(walletId);
//       return { walletId, history: res.data.data || res.data };
//     } catch (e) {
//       return rejectWithValue("Failed to load history");
//     }
//   }
// );

export const fetchWalletHistory = createAsyncThunk(
  "wallet/fetchHistory",
  async (
    { walletId = null, search = "", page = 1, pageSize = 10 },
    { rejectWithValue }
  ) => {
    try {
      const res = await walletApi.getHistory(walletId, search, page, pageSize);
      const historyData = res.data?.data || res.data || [];
      const pagination = res.data?.pagination || { count: historyData.length };

      return {
        walletId,
        history: historyData,
        pagination,
        search,
      };
    } catch (e) {
      return rejectWithValue("Failed to load wallet history");
    }
  }
);

/* -------------------------- EXPORT THUNKS -------------------------- */
export const exportWallets = createAsyncThunk(
  "wallet/exportWallets",
  async (_, { rejectWithValue }) => {
    try {
      const blob = await walletApi.exportWallets();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `employee_wallets_${new Date()
        .toISOString()
        .slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      return { success: true };
    } catch (err) {
      return rejectWithValue("Failed to export wallets");
    }
  }
);

export const exportWalletHistory = createAsyncThunk(
  "wallet/exportHistory",
  async (_, { rejectWithValue }) => {
    try {
      const blob = await walletApi.exportHistory();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `wallet_transaction_history_${new Date()
        .toISOString()
        .slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      return { success: true };
    } catch (err) {
      return rejectWithValue("Failed to export transaction history");
    }
  }
);

const walletSlice = createSlice({
  name: "wallet",
  initialState: {
    wallets: [], // Only current page wallets
    history: {}, // { global: { items, pagination }, "walletId": { ... } }
    pagination: {
      // Shared pagination for wallets list
      count: 0,
      current_page: 1,
      total_pages: 1,
      page_size: 10,
    },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // === Fetch Wallets ===
      .addCase(fetchWallets.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchWallets.fulfilled, (state, action) => {
        state.isLoading = false;

        // Handle both { data, pagination } and plain array responses
        const payload = action.payload;

        if (Array.isArray(payload)) {
          // Old API: just array
          state.wallets = payload;
          state.pagination = {
            count: payload.length,
            current_page: 1,
            total_pages: 1,
            page_size: state.pagination.page_size,
          };
        } else {
          // New paginated API
          state.wallets = payload.data || [];
          state.pagination = {
            count: payload.pagination?.count || state.wallets.length,
            current_page: payload.pagination?.current_page || 1,
            total_pages: payload.pagination?.total_pages || 1,
            page_size: payload.pagination?.page_size || 10,
          };
        }
      })
      .addCase(fetchWallets.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(creditWallet.fulfilled, (state, action) => {
        const idx = state.wallets.findIndex((w) => w.id === action.payload.id);
        if (idx !== -1) state.wallets[idx] = action.payload;
      })
      .addCase(creditWallet.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchWalletHistory.pending, (state) => {
        state.isLoading = true;
      })
      // .addCase(fetchWalletHistory.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.history[action.payload.walletId] = action.payload.history;
      // })
      .addCase(fetchWalletHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        const { walletId, history, pagination } = action.payload;

        // FIXED: Store global history under key "global" (not null)
        const key = walletId === null ? "global" : walletId;
        state.history[key] = {
          items: history,
          pagination,
        };
      })
      .addCase(fetchWalletHistory.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(debitWallet.fulfilled, (state, action) => {
        const idx = state.wallets.findIndex((w) => w.id === action.payload.id);
        if (idx !== -1) state.wallets[idx] = action.payload;
      })
      .addCase(debitWallet.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(exportWallets.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(exportWalletHistory.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearError } = walletSlice.actions;
export default walletSlice.reducer;
